/*
 * @Author: Haotao
 * @Date: 2022-10-11 16:05:43-18 11:33:00
 * @LastEditors: Haotao
*/

let record = {
  comnpanyName: '中芯云服（浙江）数字科技有限公司',
  icpNo: '浙ICP备2022030660号-1'
};

const { origin } = window.location;
// if (origin.indexOf('https://h5.zhongxincloud.net') > -1) {
if (origin.indexOf('https://h5.zhongxincloud.net/') > -1) {
  //生产地址
  record.comnpanyName = '中芯云服（浙江）数字科技有限公司';
  record.icpNo = '浙ICP备2022030660号-1';
} else if (origin.indexOf('https://m.xiydr.cn') > -1) {
  //测试地址
  record.comnpanyName = '中芯云服（浙江）数字科技有限公司';
  record.icpNo = '浙ICP备2022030660号-1';
}

export default record;